module.exports = __webpack_public_path__ + "img/icon-zoom-out.7113ec6c.svg";